import { render, staticRenderFns } from "./chat-history.vue?vue&type=template&id=0cbedd94&scoped=true"
import script from "./chat-history.vue?vue&type=script&lang=js"
export * from "./chat-history.vue?vue&type=script&lang=js"
import style0 from "./chat-history.vue?vue&type=style&index=0&id=0cbedd94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbedd94",
  null
  
)

export default component.exports